<template>
  <div>
    <section-title id="welcome">
      {{ $t("documents-welcome-booklet") }}
    </section-title>
    <b-card class="mb-3 shadow">
      <b-media>
        <svgicon
          slot="aside"
          icon="invoice"
          width="52"
          height="52"
          color="#ddd"
        ></svgicon>

        {{ $t("documents-welcome-booklet-description") }}
        <!-- <p class="m-0">
              Ceci est un message indicatif
            </p> -->
      </b-media>
      <div slot="footer">
        <b-btn
          :href="livretDaccueil"
          target="_blank"
          variant="primary"
          size="sm"
        >
          <svgicon icon="play" class="mr-1"></svgicon>
          {{ $t("documents-download-btn") }}
        </b-btn>
      </div>
    </b-card>
  </div>
</template>

<script>
import SectionTitle from "../../SectionTitle.vue";
import DocumentService from "../../../services/document";
import { COMPONENT_KEYWORD } from "../../../constants/variables";
export default {
  created() {
    this.getDocumentWelcomeKit();
  },
  components: {
    SectionTitle
  },
  data() {
    return {
      livretDaccueil: "download/livret-accueil-client-vitalliance.pdf"
    };
  },
  methods: {
    getDocumentWelcomeKit() {
      DocumentService.getComponentBykeyword({
        keyword: COMPONENT_KEYWORD.DOCUMENTS_WELCOME_KIT_CLIENT
      }).then(res => {
        if (res && res.components && res.components.length > 0) {
          this.livretDaccueil = res.components[0].urlFile;
        }
      });
    }
  }
};
</script>
